// extracted by mini-css-extract-plugin
module.exports = {"pageStyle":"SbuStatusChangePopup_pageStyle__2K3FF","dialogCard":"SbuStatusChangePopup_dialogCard__2pnYd"};